import React from 'react';
import PropTypes from 'prop-types';
import useDetailsShower from './hooks/details';
import Results from './results';
import { RENDER_API_URL } from './hooks/consts';
import IconAlert from '../../components/blanks/common/IconAlert';
import { Loader } from '../../components/bootStrap';

function DetailsShower({ reportId, renderReportUrl, settings }) {
  const {
    loading,
    err,
    results,
  } = useDetailsShower({ reportId, settings, renderReportUrl });
  return (
    <>
      {err && (
        <IconAlert variant="danger">
          {err}
        </IconAlert>
      )}
      {loading && (
      <Loader />
      )}
      {results ? (
        <Results
          result={results}
        />
      ) : <div style={{ height: '100px' }} />}

    </>
  );
}

DetailsShower.propTypes = {
  reportId: PropTypes.string.isRequired,
  settings: PropTypes.shape({}).isRequired,
  renderReportUrl: PropTypes.oneOf([RENDER_API_URL]).isRequired,
};

export default DetailsShower;
